export const DEFAULT_ECT = 'ECT';
export const DEFAULT_FLT = 'FLT';
export const DEFAULT_ADT = 'ADT';
export const DEFAULT_RFEC = 'RFEC';
export const DEFAULT_VALUE_CALIBRATION = 1;
export const DEFAULT_VALUE_INSPECTION = 2;
export const DEFAULT_VALUE_CODES = 3;
export const DEFAULT_VALUE_TEXTS = 4;
export const INSPECTION_UTILITY_TYPE = 'Inspection';
